
export { LogError } from "/home/runner/work/apollo/apollo/packages/features/logger/src/presentation/templates/log-error/log-error.tsx"